
    import './styles.scoped.css';
    export default {
  "header-cell": "awsui_header-cell_1spae_su4n7_93",
  "header-cell-sticky": "awsui_header-cell-sticky_1spae_su4n7_106",
  "header-cell-stuck": "awsui_header-cell-stuck_1spae_su4n7_109",
  "header-cell-variant-full-page": "awsui_header-cell-variant-full-page_1spae_su4n7_109",
  "header-cell-hidden": "awsui_header-cell-hidden_1spae_su4n7_112",
  "header-cell-sortable": "awsui_header-cell-sortable_1spae_su4n7_115",
  "sticky-cell": "awsui_sticky-cell_1spae_su4n7_118",
  "sticky-cell-pad-left": "awsui_sticky-cell-pad-left_1spae_su4n7_126",
  "has-selection": "awsui_has-selection_1spae_su4n7_126",
  "sticky-cell-last-left": "awsui_sticky-cell-last-left_1spae_su4n7_129",
  "resize-divider": "awsui_resize-divider_1spae_su4n7_133",
  "sticky-cell-last-right": "awsui_sticky-cell-last-right_1spae_su4n7_136",
  "sorting-icon": "awsui_sorting-icon_1spae_su4n7_151",
  "edit-icon": "awsui_edit-icon_1spae_su4n7_159",
  "header-cell-content": "awsui_header-cell-content_1spae_su4n7_165",
  "header-cell-fake-focus": "awsui_header-cell-fake-focus_1spae_su4n7_198",
  "header-cell-disabled": "awsui_header-cell-disabled_1spae_su4n7_219",
  "header-cell-sorted": "awsui_header-cell-sorted_1spae_su4n7_219",
  "header-cell-text": "awsui_header-cell-text_1spae_su4n7_233",
  "header-cell-text-wrap": "awsui_header-cell-text-wrap_1spae_su4n7_237",
  "header-cell-ascending": "awsui_header-cell-ascending_1spae_su4n7_243",
  "header-cell-descending": "awsui_header-cell-descending_1spae_su4n7_244",
  "is-visual-refresh": "awsui_is-visual-refresh_1spae_su4n7_254",
  "has-striped-rows": "awsui_has-striped-rows_1spae_su4n7_265"
};
  